import { STEPS } from '../../utils/routes.util';

export default BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(STEPS.ACCUEIL_INTERFACE_1, {
    url: '/accueil-interface-1',
    template: '<dmattnt-accueil-interface-1></dmattnt-accueil-interface-1>',
    //on a joute un label pour afficher dans le fil d'ariane
    data: {label: 'Pré-requis'}
  }).state(STEPS.ACCUEIL_INTERFACE_2, {
    url: '/accueil-interface-2',
    template: '<dmattnt-accueil-interface-2></dmattnt-accueil-interface-2>',
    data: {label: 'Adresse impactée'}
  }).state(STEPS.ACCUEIL_INTERFACE_3, {
    url: '/accueil-interface-3',
    template: '<dmattnt-accueil-interface-3></dmattnt-accueil-interface-3>',
    data: {label: 'Adresse non confirmée'}
  }).state(STEPS.ETAT_CHAINES, {
    url: '/etat-chaines',
    template: '<dmattnt-etat-chaines></dmattnt-etat-chaines>',
    data: {label: 'Etat des chaînes'}
  }).state(STEPS.REAMENAGEMENT, {
    url: '/reamenagement',
    template: '<dmattnt-reamenagement></dmattnt-reamenagement>',
    data: {label: 'Changement de fréquences'}
  }).state(STEPS.ANTENNE_ACCESSIBLE, {
    url: '/antenne-accessible',
    template: '<dmattnt-antenne-accessible></dmattnt-antenne-accessible>',
    data: {label: 'Antenne accessible'}
  }).state(STEPS.FIN_ACCUEIL, {
    url: '/fin-accueil',
    template: '<dmattnt-fin-accueil></dmattnt-fin-accueil>',
    data: {label: 'Conclusion accueil'}
  }).state(STEPS.INTERVENTION_ANTENNISTE, {
    url: '/intervention-antenniste',
    template: '<dmattnt-intervention-antenniste></dmattnt-intervention-antenniste>',
    data: {label: 'Intervention antenniste'}
  }).state(STEPS.SIGNALEMENT_ANTENNISTE, {
    url: '/signalement-antenniste',
    template: '<dmattnt-signalement-antenniste></dmattnt-signalement-antenniste>',
    data: {label: 'Signalement antenniste'}
  }).state(STEPS.INCIDENT_DETECTE, {
    url: '/incident-detecte',
    template: '<dmattnt-incident-detecte></dmattnt-incident-detecte>',
    data: {label: 'Incident détecté'}
  }).state(STEPS.AUCUN_INCIDENT_DETECTE, {
    url: '/aucun-incident-detecte',
    template: '<dmattnt-aucun-incident-detecte></dmattnt-aucun-incident-detecte>',
    data: {label: 'Aucun incident détecté'}
  }).state(STEPS.DYSFONCTIONNEMENT_INTERFACE, {
    url: '/dysfonctionnement-interface',
    template: '<dmattnt-dysfonctionnement-interface></dmattnt-dysfonctionnement-interface>',
    data: {label: 'Type du Dysfonctionnement'}
  }).state(STEPS.CONCLUSION, {
    url: '/conclusion',
    template: '<dmattnt-conclusion></dmattnt-conclusion>',
    data: {label: 'À bientôt'}
  });
}



// WEBPACK FOOTER //
// ./src/modules/accueil/routes.js